import { render } from "./vr.vue?vue&type=template&id=e42b7d78&ts=true"
import script from "./vr.vue?vue&type=script&lang=ts"
export * from "./vr.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\work\\CP_new_work\\saas-h5-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__